// 获取网站站点源数据
export default async function ({ app, store, $winstonLog }) {
  if (!store.state.source || Object.keys(store.state.source).length === 0) {
    try {
      const { data } = await app.$axios.get('/cms/archives_data', {
        params: {
          unique_id:
            'jzyx_base_config,jzyx_base_logo,jzyx_base_menu,jzyx_about_culture_next,jzyx_base_licence,jzyx_base_links,jzyx_background_video,jzyx_promo_video,jzyx_landing_games,jzyx_landing_about,jzyx_landing_timeline,jzyx_landing_join',
        },
      })
      return data.data && store.dispatch('SetSource', data.data)
    } catch ({ response }) {
      const { status, statusText, config } = response || {}
      $winstonLog.error(
        `${new Date()} ${config.baseURL}${config.url} ${status} ${statusText}`
      )
    }
  }
}
